import { DOCTYPES } from '@/constants/doctypes'
import { HAS_LIST_VIEW_ONE_PERMISSION_OF } from '@/constants/permissions'
import { createSingleViewRoutes } from '@/routers/routes/createDoctypeRoutes'

const { home: routeAccountingDashboardHome, root: routeAccountingDashboardRoot } =
  createSingleViewRoutes({
    doctypes: {
      [DOCTYPES.PAYMENT_ENTRY]: HAS_LIST_VIEW_ONE_PERMISSION_OF,
      [DOCTYPES.PURCHASE_INVOICE]: HAS_LIST_VIEW_ONE_PERMISSION_OF,
      [DOCTYPES.SALES_INVOICE]: HAS_LIST_VIEW_ONE_PERMISSION_OF,
    },
    ifOwner: false,
    name: 'accounting-dashboard',
    path: 'dashboard',
    view: async () => await import('@/components/views/accounting/AccountingDashboard.vue'),
  })

export { routeAccountingDashboardHome, routeAccountingDashboardRoot }
